import { InsightData } from 'schemas/action/InsightDataSchema'
import { Filter } from 'schemas/FilterSchema'
import { SearchFilterComposingStrategy } from './searchFilterComposingStrategy'

const composeDetailSearchFilter = (filter: Filter, insights: InsightData[]) => ({
  ...filter,
  orgProducts: [
    ...(filter.orgProducts || []),
    Array.from(insights).flatMap((insight) => [insight.name, ...(insight.variants || [])])
  ]
})

const generateBrandsInsightStrategy = (): SearchFilterComposingStrategy => ({
  composeDetailSearchFilter
})

export default generateBrandsInsightStrategy
